export default "__VITE_ASSET__Cyy5EF7P__"